// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1xmbw","sendOtp":"AuthorizeToLogin_sendOtp__fawJ4"};